import * as types from './types'
import logApi from '../api'

export const actions = {
    async [types.LOG_FETCH]({commit}, data = null) {
        commit(types.LOG_SET_LOADING, true)
        const response = await logApi.all(data)
        commit(types.LOG_OBTAIN, response.data.data)
        commit(types.LOG_META, response.data.meta)
        commit(types.LOG_SET_LOADING, false)
    },
}
